import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthenticationService} from '../../services/authentication.service';
import {NotificationService} from '../../../shared/utils/notification.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    loading = false;
    username: string;
    password: string;
    loadingButtonTitle: string;

    constructor(
        private router: Router,
        private _authService: AuthenticationService,
        private notificationService: NotificationService
    ) {}

    ngOnInit() {
    }

    login() {
        this.loading = true;        
        this.changeButtonLoadingTitleAfterTime();
        this._authService.login(this.username, this.password)
            .subscribe(() => {
                this.loading = false;
                this.router.navigate(['/dashboard']);
                this.successMessage();
            }, () => {
                this.loading = false;
                this.errorMessage();
            })
    }

    private changeButtonLoadingTitleAfterTime() {   
        this.loadingButtonTitle = 'Prihlasujem...';    
        setTimeout(() => {
            this.loadingButtonTitle = 'Môže to chvíľu trvať...';
        }, 3000);

        setTimeout(() => {
            this.loadingButtonTitle = 'Ešte trošku vydržte...';
        }, 7000);

        setTimeout(() => {
            this.loadingButtonTitle = 'Fakt sa snažíme...';
        }, 12000);

        setTimeout(() => {
            this.loadingButtonTitle = 'Už to skoro bude...';
        }, 16000);

        setTimeout(() => {
            this.loadingButtonTitle = 'A.. Aaa.. Aaaaaa... :)';
        }, 20000);

        setTimeout(() => {
            this.loadingButtonTitle = 'A.. neskúsite to neskôr? :P';
        }, 25000);
    }

    /* ##### Alert messages ##### */
    successMessage() {
        this.notificationService.smallBox({
            title: 'Používateľ prihlásený',
            content: 'Prihlásenie do systému prebehlo úspešne.',
            color: '#296191',
            timeout: 3000
        });
    }

    errorMessage() {
        this.notificationService.smallBox({
            title: 'Chyba',
            content: 'Vyskytla sa chyba počas prihlasovania. Skontrolujte prosím Vaše prihlasovacie údaje.',
            color: '#aa3333',
            timeout: 5000
        });
    }

}



// WEBPACK FOOTER //
// ./src/app/+app-custom/views/login/login.component.ts